module.exports = __webpack_public_path__ + "img/forest_al.138644c2.svg";